import React from 'react';
import MiniAppMain from './components/MiniAppMain';
import './App.css';

function App() {
  return (
    <div className="App">
      <MiniAppMain />
    </div>
  );
}

export default App; 